import React from 'react'
import './AddNewTemplates.scss'
import asideModalStore from 'Stores/asideModalStore'
import FormFieldset from 'components/UI/AsideModal/Form/FormFieldset'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'
import FormInput from 'components/UI/AsideModal/Form/FormInput'
import FormField from 'components/UI/AsideModal/Form/FormField'
import SelectCustom from 'components/ContentBox/Global/Select/SelectCustom'
import { observer } from 'mobx-react'
import CheckboxToggle from 'components/ContentBox/Global/CheckboxToggle/CheckboxToggle'
import Flex from 'components/UI/Flex/Flex'

const AddNewTemplates = () => {
  const { modalValues, changeValue, check } = asideModalStore

  return (
    <FormFieldset>
      <FormField>
        <FormLabel isRequired>Название шаблона:</FormLabel>
        <FormInput isError={check('title')}>
          <input
            placeholder={'Название шаблона'}
            type='title'
            value={modalValues.title || ''}
            onChange={(e) => changeValue(e.target.value, 'title')}
          />
        </FormInput>
      </FormField>
      <FormField>
        <FormLabel isRequired>Текст шаблона:</FormLabel>
        <FormInput isError={check('text')}>
          <textarea
            placeholder={'Текст шаблона'}
            type='text'
            value={modalValues?.text || ''}
            onChange={(e) => changeValue(e.target.value, 'text')}
          />
        </FormInput>
      </FormField>
      <FormField>
        <FormLabel isRequired>Выбрать канал:</FormLabel>
        <SelectCustom
          placeholder={'Выбрать канал'}
          valueID={modalValues?.channel || []}
          onChange={(temp) => changeValue(temp.channel_id, 'channel')}
          apiLinkCRM={'integration/channels'}
          error={check('channel')}
          optionValueKey='channel_id'
          getOptionValue={(option) => option.channel_id}
        />
      </FormField>
      <FormField>
        <Flex>
          <CheckboxToggle
            right={'Сделать активным'}
            checked={modalValues?.is_active}
            onChange={() => changeValue(!modalValues?.is_active, 'is_active')}
          />
        </Flex>
      </FormField>
    </FormFieldset>
  )
}

export default observer(AddNewTemplates)
